import { useQuery } from '@tanstack/react-query';
import { getListingEmailStatuses } from '../../../api/ListingEmails/listingEmails';
import { ListingEmailStatus, statusByProperty } from '../../../utility/listingEmail';

// Which of a list's properties can be emailed to their listing agent. Only asked for when email mode is on.
export function useListingEmailStatuses(listSortId: string | undefined, enabled: boolean) {
  const query = useQuery({
    queryKey: [ 'listingEmails', listSortId ],
    queryFn: () => getListingEmailStatuses(listSortId as string),
    enabled: enabled && !!listSortId,
    retry: false,
  });
  const results = (query.data?.data.results as ListingEmailStatus[]) || [];
  const emailClient = (query.data?.data.email_client as string | undefined) ?? 'outlook_desktop';
  return { statuses: statusByProperty(results), emailClient, isLoading: query.isLoading, error: query.error };
}
